import { h, FunctionalComponent } from 'preact';
import register from 'preact-custom-element';
import { TocDesktopHeadline } from './TocDesktopHeadline';
import { TocDesktopItem } from './TocDesktopItem';
import { ParsedTocPropsDesktop, UnparsedTocPropsDesktop } from './TocPropsTypes';

const parseProps = (unparsedProps: UnparsedTocPropsDesktop): ParsedTocPropsDesktop => {
	const parsedProps: ParsedTocPropsDesktop = {
		headline: JSON.parse(unparsedProps.headline),
		items: JSON.parse(unparsedProps.items),
	};
	return parsedProps;
};

export const TocDesktop: FunctionalComponent<UnparsedTocPropsDesktop> = (unparsedProps) => {
	const props = parseProps(unparsedProps);
	const { items, headline } = props;
	return (
		<div className="SP-Toc__box--desktop SP-Toc__box">
			<div className="SP-TocDesktop">
				<TocDesktopHeadline {...headline} />
				<ol className="SP-TocList__list SP-TocDesktop__list">
					{items.map((item) => (
						<TocDesktopItem {...item} />
					))}
				</ol>
			</div>
		</div>
	);
};
register(TocDesktop, 'sp-toc-desktop', ['headline', 'items'], { shadow: false });
